import { generateClient } from 'aws-amplify/api'
import {
  listOnCallActions,
  getOnCallAction,
  testOnCallAction,
  getTestCallResult,
  getActionTemplate,
} from '@/graphql/queries'
import {
  createOnCallAction,
  updateOnCallAction,
  deleteOnCallAction,
  enableOnCallAction,
  disableOnCallAction,
  configureTemplateAction,
} from '@/graphql/mutations'
import { parseAwsJson } from '@/utils/graphql'
import { getApiMessage } from '@/mixins/Extras/ApiResponse'

import {
  sanitizeCreateOnCallActionInput,
  sanitizeUpdateOnCallActionInput,
  sanitizeTestOnCallActionInput,
} from '@/utils/onCallActions'

const client = generateClient()

async function runGraphql(query, input, field, sanitizeInput) {
  try {
    const payload = sanitizeInput ? sanitizeInput(input) : input
    const { data, errors } = await client.graphql({
      query,
      variables: { input: payload },
    })

    if (errors?.length) {
      throw new Error(errors[0].message)
    }

    return parseAwsJson(data?.[field])
  } catch (error) {
    return {
      status: 'ERROR',
      message: getApiMessage(error, 'Request failed'),
    }
  }
}

export async function fetchOnCallActions(input = {}) {
  return runGraphql(listOnCallActions, input, 'listOnCallActions')
}

export async function fetchOnCallAction(input = {}) {
  return runGraphql(getOnCallAction, input, 'getOnCallAction')
}

export async function testOnCallActionApi(input = {}) {
  return runGraphql(testOnCallAction, input, 'testOnCallAction', sanitizeTestOnCallActionInput)
}

export async function fetchTestCallResultApi(input = {}) {
  const uuid = String(input?.uuid ?? '').trim()
  return runGraphql(getTestCallResult, { uuid }, 'getTestCallResult')
}

export async function fetchActionTemplate(input = {}) {
  return runGraphql(getActionTemplate, input, 'getActionTemplate')
}

export async function configureTemplateActionApi(input = {}) {
  return runGraphql(configureTemplateAction, input, 'configureTemplateAction')
}

export async function createOnCallActionApi(input = {}) {
  return runGraphql(createOnCallAction, input, 'createOnCallAction', sanitizeCreateOnCallActionInput)
}

export async function updateOnCallActionApi(input = {}) {
  return runGraphql(updateOnCallAction, input, 'updateOnCallAction', sanitizeUpdateOnCallActionInput)
}

export async function deleteOnCallActionApi(input = {}) {
  return runGraphql(deleteOnCallAction, input, 'deleteOnCallAction')
}

export async function enableOnCallActionApi(input = {}) {
  return runGraphql(enableOnCallAction, input, 'enableOnCallAction')
}

export async function disableOnCallActionApi(input = {}) {
  return runGraphql(disableOnCallAction, input, 'disableOnCallAction')
}
